import { OrderStatus } from "lib/api/enum";

export const getOrderStatusStepString = (
    parcel: boolean,
    status: OrderStatus
) => {
    console.log("getOrderStatusStepString : ", parcel, status);

    let text = "";
    switch (status) {
        case OrderStatus.COMPLETE_PAYMENT:
            if (parcel) text = "택배원이 제품 픽업을 준비중 입니다";
            else text = "버틀러가 제품 픽업을 준비중 입니다";
            break;
        case OrderStatus.CANCEL_ORDER:
            text = "모든 주문이 취소되었습니다.";
            break;
        case OrderStatus.PICKUP:
            if (parcel) text = "픽업중";
            else text = "픽업중";
            break;
        case OrderStatus.PICKUP_COMPLETE:
            if (parcel) text = "제품도착";
            else text = "픽업완료";
            break;
        case OrderStatus.MINTING:
            text = "민트중";
            break;
        case OrderStatus.MINT_COMPLETE:
            text = "민트완료";
            break;
        case OrderStatus.SHIPPING:
            text = "배송중";
            break;
        case OrderStatus.DELIVERY_COMPLETE:
            text = "배송이 완료되었습니다.";
            break;
        case OrderStatus.REJECT_ORDER:
            text = "모든 주문이 취소되었습니다.";
            break;
        case OrderStatus.REQUESTING:
            text = "견적요청중";
            break;
        case OrderStatus.WAITING_ORDER:
            text = "주문대기중";
            break;
        default:
            text = "기타";
            break;
    }
    return text;
};

export const getOrderStatusString = (
    deliveryMethod: number,
    status: OrderStatus
) => {
    console.log("getOrderStatusString : ", deliveryMethod, status);

    let text = "";
    switch (status) {
        case OrderStatus.COMPLETE_PAYMENT:
            if (deliveryMethod === 0) text = "픽업준비중";
            else text = "발송대기";
            break;
        case OrderStatus.CANCEL_ORDER:
            text = "주문취소";
            break;
        case OrderStatus.PICKUP:
            if (deliveryMethod === 0) text = "픽업중";
            else text = "픽업중";
            break;
        case OrderStatus.PICKUP_COMPLETE:
            if (deliveryMethod === 0) text = "픽업완료";
            else text = "제품도착";
            break;
        case OrderStatus.MINTING:
            text = "민트중";
            break;
        case OrderStatus.MINT_COMPLETE:
            text = "민트완료";
            break;
        case OrderStatus.SHIPPING:
            text = "배송중";
            break;
        case OrderStatus.DELIVERY_COMPLETE:
            text = "배송완료";
            break;
        case OrderStatus.REJECT_ORDER:
            text = "주문취소";
            break;
        case OrderStatus.REQUESTING:
            text = "견적요청중";
            break;
        case OrderStatus.WAITING_ORDER:
            text = "주문대기중";
            break;
        default:
            text = "기타";
            break;
    }
    return text;
};
